export default __webpack_public_path__ + "a693fed4ea610da49568f7acdf7a53bd.png";